'use client';

import { formatNumber } from '@campaign-manager/core/lib/utils';
import { useLocalization } from '@campaign-manager/feature/context/Localization';

import Value from '../Value';

interface Props {
  value: number | null | undefined;
  locale?: string | null | undefined;
  placeholder?: string;
}

export default function NumberValue({ value, placeholder }: Props) {
  const { numberFormatLocale: locale } = useLocalization();
  return (
    <Value
      value={NumberString({ value, locale })}
      placeholder={placeholder}
    />
  );
}

export function NumberString({ value, locale }: Props) {
  return value != null ? formatNumber(value, locale ?? undefined) : undefined;
}
